import React, { useContext } from 'react';
import { Plural, Trans } from '@lingui/macro';
import styles from './pagination.scss';
import { DispatchContext, StateContext } from '../state/contexts';
import State from '../state/state';

const Pagination = () => {
  const state: State = useContext(StateContext);
  const dispatch = useContext(DispatchContext);
  const { pagination } = state;

  return (
    <>
      {pagination.total > 0 && (
        <div className={`${styles.pagination}`}>
          <p className="dvinci-page-label" role="status">
            {pagination.max} / <Plural value={pagination.total} one="# Job Offer" other="# Job Offers" />
          </p>

          {pagination.hasNext && (
            <button
              type="button"
              className="dvinci-pagination-button btn btn-secondary"
              onClick={() => dispatch({ type: 'next-page' })}
            >
              <Trans>More</Trans>
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default Pagination;
